<template>
    <div class="article-box-wrapper">
        <router-link :to="articleUrl" class="article-image-wrapper" v-lazyload :style="{backgroundImage: `url('${article.imgUrl}')`}">
            <div class="article-title-container-mobile">
                <div class="article-title-mobile">{{article.title}}</div>
                <div class="article-date-mobile" v-if="!isGiftList">{{formattedDate}}</div>
            </div>
        </router-link>
        <div class="article-details">
            <div class="article-details-title">
                <router-link :to="articleUrl" class="article-title">{{article.title}}</router-link>
            </div>
            <div class="article-details-desc">
                <div class="article-desc">{{article.desc}}</div>                
                <div class="article-button">
                    <router-link :to="articleUrl" class="button-link">
                        <button class="button button-explore">Explore</button>
                    </router-link>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
    import { computed, ref } from 'vue'
    import { useRoute } from 'vue-router'
    import { Article } from '@/classes/Articles'

    const props = defineProps<{
        article: Article
    }>()

    const route = useRoute()
    const articleUrl = ref('')
    const isGiftList = ref(false)

    const formattedDate = computed(() => {
        if (!props.article.date) return ''
        const date = new Date(props.article.date)
        return date.toLocaleDateString('en-US', {
            year: 'numeric',
            month: 'short',
            day: 'numeric'
        })
    })

    const init = () => {
        if (route.name === 'giftideas' || props.article.isGiftList) {
            isGiftList.value = true
            articleUrl.value = '/gift-ideas/' + props.article.articleId + '/' + props.article.prettyTitle
        } else {
            isGiftList.value = false
            articleUrl.value = '/list/' + props.article.articleId + '/' + props.article.prettyTitle
        }
    }

    init()
</script>
